import { EmployeeCloseMeetingInput, EmployeeCloseMeetingMutation } from '../../../types'
import { EMPLOYEE_CLOSE_MEETING } from '../MeetingMutations'
import { FetchResult, useMutation } from '@apollo/client'
import { MEETINGS_HISTORY_BY_REPLYER } from '../meeting.graphql'
import { OBJECTIVE_DTO_LIST } from '../../objectives/ObjectiveQuery'
import { MEETINGS_AND_REQUESTS_BY_REPLYER } from '../MeetingRequestQueries'

export const useEmployeeCloseAppraisalMeeting = (): {
  employeeCloseMeeting: (meeting: EmployeeCloseMeetingInput) => Promise<FetchResult<EmployeeCloseMeetingMutation>>
  loading: boolean
} => {
  const [closeMeeting, { loading }] = useMutation(EMPLOYEE_CLOSE_MEETING)
  const employeeCloseMeeting = (meeting: EmployeeCloseMeetingInput): Promise<FetchResult<EmployeeCloseMeetingMutation>> => {
    return closeMeeting({
      variables: {
        meetingInput: {
          id: meeting.id,
          employeeId: meeting.employeeId,
          meetingStatus: meeting.meetingStatus,
          feedbackForHR: meeting.feedbackForHR,
        },
      },
      refetchQueries: [
        {
          query: MEETINGS_HISTORY_BY_REPLYER,
          variables: {
            replyerId: meeting.employeeId,
            isResigned: false,
          },
        },
        {
          query: OBJECTIVE_DTO_LIST,
          variables: {
            employeeId: meeting.employeeId,
          },
        },
        {
          query: MEETINGS_AND_REQUESTS_BY_REPLYER,
          variables: {
            replyerId: meeting.employeeId,
            disputedMeetingsIncluded: true,
          },
        },
      ],
    })
  }

  return { employeeCloseMeeting, loading }
}
